import { React, useCallback, useEffect } from 'react';
import { useState } from 'react';
import Grid from '@mui/material/Grid';
import { CmpButton, CmpCheckboxField, CmpTypographyField } from '../../component/ToolBox/ToolBox';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';
// import CardContent from '@mui/material/CardContent';
// import Typography from '@mui/material/Typography';
import { styled as styleMui } from '@mui/material/styles';
import 'react-circular-progressbar/dist/styles.css';
import styled from 'styled-components';
import Modal from '@mui/material/Modal';
import PostModal from './ProcessComponents/PostModal';
import MarginPostingByOrder from './ProcessComponents/MarginPostingByOrder';
import './Order.css';
import OrderCardContent from './ProcessComponents/OrderCardContent';
import { useDispatch, useSelector } from 'react-redux';
import { getOrderItems, getDCMarginByOrder, postDCMarginByOrder } from './action';
import { updateOrderMarginStatus } from './OrderSlice';
import { fAlertToast } from '../../Utility/Utilitys';
import PurchaseStatusIcon from './ProcessComponents/PurchaseStatusIcon';
import OrderBreadCrumbs from './ProcessComponents/OrderBreadCrumbs';
import { ToastContainer } from 'react-toastify';
import moment from 'moment';

const StyledDiv = styled.div`
  overflow: auto;
  display: block;
  // height: 35rem ;
  text-align: center;
  //margin:auto 3rem;
`;

const BoxDiv = styled.div`
  border: 1px solid #0d73be;
  border-radius: 5px;
  // background-color: #0d73bb;
  // color: #fff;
  margin: 5px;
  // text-align: center;
  // cursor:pointer;
  box-shadow: 0px 0px 3px 0px #0d73be;
  //max-width:20rem;
  // padding:5px;
  // height:10rem;
`;

export default function OrderDetail() {
  const dispatch = useDispatch();
  const [sPostModal, setPostModal] = useState(false);
  const [sItemList, setItemList] = useState([]);

  const [sMarginModalOpen, setMarginModalOpen] = useState(false);
  const [sMarginRows, setMarginRows] = useState([]);
  const [sMarginStatus, setMarginStatus] = useState('ENTER');

  const rdxOrderHead = useSelector((state) => state.OrderSlice.orderHead);
  const rdxUser = useSelector((state) => state.SliceDB.value.login);
  const fShowPostModal = (show) => {
    setPostModal(show);
  };

  const loadDetails = useCallback(async () => {
    let reqObj = {
      orderId: rdxOrderHead.orderId
    };
    const res = await getOrderItems(reqObj);

    setItemList(res.ResultSet);
  }, [rdxOrderHead, getOrderItems, setItemList]);

  useEffect(() => {
    loadDetails();
  }, [loadDetails]);

  // Recalculate added margin from item-level overhead margin % when row is unposted
  const fRecalcMargins = (rows) =>
    rows?.map((obj) => {
      if (obj?.TRNS_Add_Margin_Base === 0) {
        let additionalMargin = (obj.X_Add_Margin / 100) * obj.TRNS_UnitRate;
        return {
          ...obj,
          TRNS_Add_Margin_Base: Number((additionalMargin / obj.TRN_PACK_QTY).toFixed(3)),
          TRNS_Add_Margin_CTN: Number(additionalMargin.toFixed(3)),
          TRNS_Add_Margin_Net: Number((additionalMargin * obj.TRNS_QTY).toFixed(3)),
          TRNS_TSR_RSP: Number((obj.TRNS_UnitRate + additionalMargin).toFixed(3)),
          TRNS_Add_Margin_Min: Number(additionalMargin.toFixed(3))
        };
      }
      return obj;
    });

  const fOpenMarginModal = async () => {
    const res = await getDCMarginByOrder({ orderId: rdxOrderHead.orderId });
    if (!res || res.Type !== 'Success') return;

    const marginStatus = res.ResultSet?.MarginStatus || 'ENTER';
    let rows = res.ResultSet?.ResultSet || [];

    if (marginStatus === 'ENTER') {
      rows = fRecalcMargins(rows);
    }

    setMarginRows(rows);
    setMarginStatus(marginStatus);
    dispatch(updateOrderMarginStatus(marginStatus));

    setMarginModalOpen(true);
  };

  const fCloseMarginModal = () => {
    setMarginModalOpen(false);
    setMarginRows([]);
  };

  const fPostMargin = async (isPost) => {
    const xTransDetail = sMarginRows.map((x) => ({
      v_TRNS_ID: x?.TRNS_ID,
      v_TRNS_SRNO: x?.TRNS_SRNO,
      v_TRNS_Add_Margin_Base: x?.TRNS_Add_Margin_Base,
      v_TRNS_Add_Margin_CTN: x?.TRNS_Add_Margin_CTN,
      v_TRNS_Add_Margin_Net: x?.TRNS_Add_Margin_Net,
      v_TRNS_TSR_RSP: x?.TRNS_TSR_RSP,
      v_TRNS_Add_Margin_Min: x?.TRNS_Add_Margin_Min,
      TRNS_ITEM_NAME: x?.ItmName
    }));
    const obj = {
      orderId: rdxOrderHead.orderId,
      v_UserCd: rdxUser?.userId,
      isPost,
      TransDetail: xTransDetail
    };
    const result = await postDCMarginByOrder(obj);
    if (result?.Type === 'Success') {
      if (isPost === true) {
        setMarginStatus('POST');
        dispatch(updateOrderMarginStatus('POST'));
        fAlertToast('SUCCESS', 'Margin Posted Successfully');
        fCloseMarginModal();
      } else {
        fAlertToast('SUCCESS', 'Margin Saved Successfully');
        await fOpenMarginModal();
      }
    }
  };

  const Item = styleMui('div')(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary
  }));

  return (
    <div className="container">
      <StyledDiv>
        <div
        // className="my-2"
        >
          <OrderBreadCrumbs xStatus={rdxOrderHead.status} />
        </div>
        <div>
          <ToastContainer />
        </div>
        <Grid
          container
          spacing={0}
          columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
          className="mb-4"
          sx={{ justifyContent: 'start' }}>
          <Grid item xs={5} sm={1} md={1.5} lg={1} align="left">
            <CmpButton
              xvariant={'contained'}
              xsize={'small'}
              xonClick={() => fShowPostModal(true)}
              xLabel={'Post'}
              xDisable={rdxOrderHead.status?.toString().toUpperCase() !== 'ENTER'}
            />
          </Grid>
          <Grid item xs={5} sm={1} md={1.5} lg={1} align="left">
            <CmpButton
              xvariant={'contained'}
              xsize={'small'}
              xonClick={fOpenMarginModal}
              xLabel={'Margin'}
              xDisable={false}
            />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={0}
          columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
          className="mb-2 text-start">
          <Grid item xs={12} sm={6} md={6}>
            <Grid container spacing={1} columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <Grid item xs={6} sm={5} md={4}>
                <CmpTypographyField xcomponent={'span'} xText={'Order ID'} />
              </Grid>
              <Grid item xs={1} sm={1} md={1}>
                <CmpTypographyField xcomponent={'span'} xText={':'} />
              </Grid>
              <Grid item xs={5} sm={6} md={7}>
                <CmpTypographyField xcomponent={'span'} xText={rdxOrderHead.orderId} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Grid container spacing={1} columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <Grid item xs={6} sm={5} md={4}>
                <CmpTypographyField xcomponent={'span'} xText={'Date'} />
              </Grid>
              <Grid item xs={1} sm={1} md={1}>
                <CmpTypographyField xcomponent={'span'} xText={':'} />
              </Grid>
              <Grid item xs={5} sm={6} md={7}>
                <CmpTypographyField
                  xcomponent={'span'}
                  xText={moment(rdxOrderHead.orderDate).format('DD/MM/YYYY')}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Grid container spacing={1} columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <Grid item xs={6} sm={5} md={4}>
                <CmpTypographyField xcomponent={'span'} xText={'No. of Invoices'} />
              </Grid>
              <Grid item xs={1} sm={1} md={1}>
                <CmpTypographyField xcomponent={'span'} xText={':'} />
              </Grid>
              <Grid item xs={5} sm={6} md={7}>
                <CmpTypographyField xcomponent={'span'} xText={rdxOrderHead.purchaseCount} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Grid container spacing={1} columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <Grid item xs={6} sm={5} md={4}>
                <CmpTypographyField xcomponent={'span'} xText={'Purchase Completion'} />
              </Grid>
              <Grid item xs={1} sm={1} md={1}>
                <CmpTypographyField xcomponent={'span'} xText={':'} />
              </Grid>
              <Grid item xs={5} sm={6} md={7}>
                <CmpTypographyField xcomponent={'span'} xText={rdxOrderHead.purCompletion + '%'} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Grid container spacing={1} columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <Grid item xs={6} sm={5} md={4}>
                <CmpTypographyField xcomponent={'span'} xText={'Purchase Accuracy'} />
              </Grid>
              <Grid item xs={1} sm={1} md={1}>
                <CmpTypographyField xcomponent={'span'} xText={':'} />
              </Grid>
              <Grid item xs={5} sm={6} md={7}>
                <CmpTypographyField xcomponent={'span'} xText={rdxOrderHead.purAccuracy + '%'} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Grid container spacing={1} columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <Grid item xs={6} sm={5} md={4}>
                <CmpTypographyField xcomponent={'span'} xText={'Deviation'} />
              </Grid>
              <Grid item xs={1} sm={1} md={1}>
                <CmpTypographyField xcomponent={'span'} xText={':'} />
              </Grid>
              <Grid item xs={5} sm={6} md={7}>
                <CmpTypographyField xcomponent={'span'} xText={rdxOrderHead.deviation} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Grid container spacing={1} columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <Grid item xs={6} sm={5} md={4}>
                <CmpTypographyField xcomponent={'span'} xText={'Cost Deviation'} />
              </Grid>
              <Grid item xs={1} sm={1} md={1}>
                <CmpTypographyField xcomponent={'span'} xText={':'} />
              </Grid>
              <Grid item xs={5} sm={6} md={7}>
                <CmpTypographyField xcomponent={'span'} xText={rdxOrderHead.costDeviation} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Grid container spacing={1} columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <Grid item xs={6} sm={5} md={4}>
                <CmpTypographyField xcomponent={'span'} xText={'DC Purchase'} />
              </Grid>
              <Grid item xs={1} sm={1} md={1}>
                <CmpTypographyField xcomponent={'span'} xText={':'} />
              </Grid>
              <Grid item xs={5} sm={6} md={7}>
                <CmpCheckboxField
                  xSize={'small'}
                  xChecked={rdxOrderHead.dcPurchase === 'Y'}
                  xDisabled={true}
                  xOnkeyUp={''}
                  xTabIndex=""
                  xref=""
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Modal
          open={sPostModal}
          onClose={() => setPostModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description">
          <Box className="model-sales-invoice-GCVanMaster-Modal">
            <PostModal orderNo={rdxOrderHead.orderId} onClose={setPostModal} itemList={sItemList} />
          </Box>
        </Modal>
        <MarginPostingByOrder
          xOpen={sMarginModalOpen}
          xTitle={'DC Margin Update - Posting'}
          fCloseModal={fCloseMarginModal}
          xOrderInfo={{
            orderId: rdxOrderHead.orderId,
            orderDate: rdxOrderHead.orderDate,
            marginStatus: sMarginStatus
          }}
          xLoadDetailRow={sMarginRows}
          xfetchPost={fPostMargin}
          setLoadDetailRow={setMarginRows}
        />
        <Grid
          container
          spacing={0.5}
          sx={{ height: '62vh', overflowY: 'auto', paddingRight: '10px' }}>
          {sItemList.map((value, i) => (
            <Grid item xs={12} sm={6} md={3} lg={3} key={value.ItmCd}>
              {/* <Box> */}
              <BoxDiv>
                {/* <CmpTypographyField xcomponent={'span'} xText={value.item.toUpperCase()} /> */}
                {/* <Typography variant='body2'>{}</Typography> */}
                <Card
                  variant="outlined"
                  onClick={() => {
                    // navigate('/OrderDetail');
                  }}>
                  {/* <div style={{ display: 'flex', justifyContent: 'space-between' }}> */}
                  <Grid container spacing={1} className="pt-2">
                    <Grid item xs={11}>
                      <CmpTypographyField xVariant="h3" xcomponent={'span'} xText={value.ItmName} />
                    </Grid>
                    <Grid item xs={1}>
                      <PurchaseStatusIcon
                        purchasedQty={value.PurchasedQty}
                        balQty={value.BasseQty - value.PurchasedQty}
                      />
                    </Grid>
                  </Grid>
                  <br />
                  {/* <h6 style={{ color: '#0d73bb' }}><b>{value.item.toUpperCase()}</b></h6><br /> */}
                  <OrderCardContent key={value.ItmCd} data={value} />
                </Card>
              </BoxDiv>
              {/* </Box > */}
            </Grid>
          ))}
        </Grid>
      </StyledDiv>
    </div>
  );
}
